module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/robust_protection.c218c510.png";